import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { IsOpen } from '../../../components/Icon';
import LoadingDetailsPageCard from '../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import cn from 'classnames';
import styles from './CardVehicleTasks.module.css';
import { selectUserId, selectWork, selectWorks } from '../../Api/selectors';
import { REQUEST_VEHICLE, REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import { KanbanVehicleRemarks } from '../../KanbanBoards/components/KanbanVehicleRemarks';

const Container = styled.div`
  font-size: 14px;
  .department {
    position: relative;
    height: 60px;
    width: 100%;
    padding: 5px;
    background-color: #eef1ef;
    border-radius: 0.375rem;
  }
  .task-cell {
    height: auto;
    padding-bottom: 10px;
  }
  .toggle-icon {
    position: absolute;
    right: 5px;
  }
`;

const STATE = {
  isOpen: true,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleTasksRemarksCardComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    // Open alle remark-secties standaard
    Object.keys(this.vehicleRemarks).forEach(name => {
      this.setState({ [`show_${name}`]: true });
    });
  }

get vehicleRemarks() {
  const { vehicle } = this.props;
  if (!vehicle) return {};

  return Object.entries(vehicle)
    .filter(([key, value]) => 
      key.toLowerCase().includes('_remarks') &&
      key !== 'product_task_other_remarks' && // <-- HIER
      value
    )
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

  toggleShow(name) {
    this.setState(prev => ({ [`show_${name}`]: !prev[`show_${name}`] }));
  }

  render() {
    const { vehicle, work } = this.props;
    if (work) return <LoadingDetailsPageCard />;

    const remarks = this.vehicleRemarks;
    const remarkKeys = Object.keys(remarks);
    
    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container id="CardVehicleTasksRemarks">
          <HBox className={styles.titleBox}>
            <h2 className="card-title mb-0 text-muted">{this.lbl('vehicle.info.tasks.task_remarks_overview')}</h2>
            <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
              <IsOpen />
            </div>
          </HBox>

          {this.state.isOpen && (
            <List>
              {remarkKeys.length === 0 && (
                <Row>
                  <Cell>
                    <em>Geen opmerkingen beschikbaar</em>
                  </Cell>
                </Row>
              )}

              {remarkKeys.map(name => (
              
                <Row key={`remark-${name}`}>
                 
                  <Cell className="task-cell">
                    <HBox className="department" vCenter left>
                      {(() => {
                        const baseName = name.replace(/_remarks$/i, '');
                        const match = baseName.match(/^product_task_other_(\d+)$/i);
        

                        if (match) {
                          const propKey = `product_task_other_${match[1]}_title`;
                          console.log ('propKey', propKey);

                          const title = vehicle?.[propKey] || '(overig zonder titel)';
                          console.log ('title', title);
                          return <strong style={{ margin: '5px', width: '40%' }}>{title} </strong>;
                        } else {
                          const labelKey = `vehicle.property.${baseName}`;
                         
                          return <strong style={{ margin: '5px', width: '40%' }}>{this.lbl(labelKey)} </strong>;
                        }
                      })()}
                      <div className="toggle-icon" onClick={() => this.toggleShow(name)}>
                        <IsOpen />
                      </div>
                    </HBox>

                    {this.state[`show_${name}`] && (
                      <HBox style={{ padding: '10px 5px' }}>
                        {/* Hier tonen we zowel de ruwe propertywaarde als remarkscomponent */}
                        <div style={{ flex: 1 }}>
                          <div style={{ marginBottom: '5px' }}>
                            {(() => {
                              let data = remarks[name];
                              // Als het een string is met JSON erin: parsen
                              if (typeof data === 'string') {
                                try {
                                  data = JSON.parse(data);
                                } catch {
                                  // geen geldige JSON, laat staan als plain text
                                  return <div>{data}</div>;
                                }
                              }

                              // Als het een array is, toon elk item
                              if (Array.isArray(data)) {
                                return data.map((r, idx) => (
                                  <div key={idx} style={{ marginBottom: '6px' }}>
                                    <div>
                                      {r.name || r.surname ? (
                                        <strong>{[r.name, r.surname].filter(Boolean).join(' ')}:</strong>
                                      ) : null}{' '}
                                      {r.text}
                                    </div>
                                    {r.date && <small style={{ color: '#888' }}>{r.date}</small>}
                                  </div>
                                ));
                              }

                              // Anders, gewoon rechtstreeks weergeven
                              return <div>{String(data)}</div>;
                            })()}
                          </div>{' '}
                          <KanbanVehicleRemarks
                            readOnly
                            vehicleTaskRemarks
                            taskName={name}
                            vehicleId={vehicle.id}
                            loggedUserId={this.props.loggedInUser}
                            fetchedVehicle={vehicle}
                          />
                        </div>
                      </HBox>
                    )}
                  </Cell>
                </Row>
              ))}
            </List>
          )}
        </Container>
      </Card>
    );
  }
}

VehicleTasksRemarksCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  work: selectWorks(REQUEST_VEHICLE, REQUEST_VEHICLE_PROPERTY_UPDATE),
  loggedInUser: selectUserId(),
  workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}`),
});

const withConnect = connect(mapStateToProps);

export const VehicleTasksRemarksCard = compose(withConnect, withRouter)(VehicleTasksRemarksCardComp);
